import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nemt-report-wrapper',
  templateUrl: './nemt-report-wrapper.component.html',
  styleUrls: ['./nemt-report-wrapper.component.css']
})
export class NemtReportWrapperComponent implements OnInit {

  subMenu = 'V1';
  constructor() { }

  ngOnInit() {
  }

  onSelectSubMenu(menu) {
    this.subMenu = menu;
  }
  ngOnDestroy(): void {

  }

}
